import { DataSender } from '../loaders'
/**
* ImportEventModal
*/

class ImportEventModal {
    constructor(target, html) {
        if(!target || !target.length || !html) return;

        // properties
        this.target = target;

        // layout
        this.target.html(html);
        this.body = this.target.find('.modal-body');
        this.form = this.target.find('form');
        this.input = this.form.find('input[name="url"]');
        this.submit = this.form.find('button');
        this.loader = this.target.find('.loader');

        // texts
        this.texts = window.importEventModalTexts;

        // init
        this.initModal();
    }

    initModal() {
        var that = this;

        this.submit.bind('click', function(e) {
            e.preventDefault();

            new DataSender({
                data: { url: that.input.val() },
                url: '/validator/facebook-event/',

                success: function(data) {
                    if(!data.valid) {
                        that.input.highlight('red', { text: that.texts.invalidUrl });
                    }
                    else {
                        that.body.css('top', '-220px');
                        that.form.css('top', '-270px');
                        that.loader.css('top', '0px');

                        window.setTimeout(function() {
                            that.form.submit();
                        }, 500);
                    }
                }
            })
        });
    }

    reset() {
        this.body.css('backgroundImage', 'url(/img/web-v2/common/import-facebook-event' + ((evedo.pixelRatio == 2) ? '@2x' : '') + '.gif?' + Math.random() + ')');
        this.input.val('');

        $('#events-menu').parent().removeClass('open');
    }
}

export { ImportEventModal }
